import { ActionType } from 'typesafe-actions';
import * as actions from './actions';

export type MyPageAction = ActionType<typeof actions>;

export type EditFieldType =
  | 'email'
  | 'managerName'
  | 'organizationName'
  | 'cellphoneNumber'
  | 'website'
  | 'department'
  | 'position'
  | 'companyIntroduction';

export interface EditProfileInputField {
  email?: string | null;
  managerName?: string | null;
  organizationName?: string | null;
  cellphoneNumber?: string | null;
  website?: string | null;
  department?: string | null;
  position?: string | null;
  companyIntroduction?: string | null;
  field: Array<{
    fieldName: string;
    content: string;
  }>;
  placeholder?: string[];
  label?: string;
}

export const initialState: EditProfileInputField = {
  email: '',
  managerName: '',
  organizationName: '',
  cellphoneNumber: '',
  website: '',
  department: '',
  position: '',
  companyIntroduction: '',
  field: [{ content: '', fieldName: '' }],
  label: undefined,
  placeholder: undefined
};
